import { slideTypes } from '@/constant/slideTypes'

const getSlideById = (state) => ({ slideId }) => {
  const slides = state.presentation?.slides
  if (!slides?.length) return null

  const slide = slides.find((s) => s.id === slideId)
  if (!slide?.id) return null

  return slide
}

const getSlideIndexById = (state) => ({ slideId }) => {
  const slides = state.presentation?.slides
  if (!slides?.length) return null

  const slideIndex = slides.findIndex((slide) => slide.id === slideId)
  if (slideIndex < 0) return null

  return slideIndex
}

const getOptionsBySlideId = ({ slideId }) => {
  const slide = getSlideById({ slideId })
  if (!slide?.SlideOptions?.length) return null

  return slide.SlideOptions
}

const getOptionBySlideId = () => ({ slideId, optionId }) => {
  const slide = getSlideById({ slideId })
  if (!slide?.SlideOptions?.length) return null

  const slideOption = slide.SlideOptions.find((option) => option.id === optionId)
  if (!slideOption?.id) return null

  return slideOption
}

const getTextBlockById = () => ({ slideId, textBlockId }) => {
  const slide = getSlideById({ slideId })
  if (!slide?.canvasBlocks?.length) return null

  const block = slide.canvasBlocks[textBlockId]
  if (!block || block?.type === 'RichText') return null

  return block
}

const slideName = () => ({ type, slideType }) => {
  if (!type) return '' // Legacy pickAnswer slides may lack slideType

  // Output: Pick Answer, Short Answer, List, Spinner Wheel, etc.
  const slide = slideTypes?.flatMap((category) => category?.slideTypes)
    .find((s) => s?.type === type && (!slideType || s?.slideType === slideType))

  if (slide) return slide.name

  if (slideTypes?.flatMap((category) => category?.slideTypes).some((s) => s?.type === type && !slideType)) {
    return 'Pick Answer'
  }

  return ''
}

const getPreviousSlide = (state) => ({ slideOrder }) => {
  const slides = state.presentation?.slides
  if (!slides?.length || !slideOrder) return null

  // Find the index of the slide with the given order
  const slideIndex = slides.findIndex((slide) => slide.order === slideOrder)
  if (slideIndex === -1 || slideIndex === 0) return null // No previous slide if at the start

  return slides[slideIndex - 1] // Return the slide before the current one
}

const getNextSlide = (state) => ({ slideOrder }) => {
  const slides = state.presentation?.slides
  if (!slides?.length || !slideOrder) return null

  // Find the index of the slide with the given order
  const slideIndex = slides.findIndex((slide) => slide.order === slideOrder)
  if (slideIndex === -1 || slideIndex === slides.length - 1) return null // No next slide if it's the last one

  return slides[slideIndex + 1] // Return the slide after the current one
}

export default {
  getSlideById,
  getSlideIndexById,
  getOptionsBySlideId,
  getOptionBySlideId,
  getTextBlockById,
  slideName,
  getPreviousSlide,
  getNextSlide,
}
